// SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

import { LitElement, html } from 'lit';
import { useStyles, attachInternals } from '@nvidia-elements/core/internal';
import styles from './avatar-group.css?inline';

/**
 * @element nve-avatar-group
 * @description An avatar group displays a collection of user avatars in a compact and organized layout, showcasing many participants or contributors in a space-efficient way.
 * @since 1.20.0
 * @entrypoint \@nvidia-elements/core/avatar
 * @slot - default slot for content
 * @aria https://www.w3.org/WAI/ARIA/apg/patterns/alert/
 *
 */
export class AvatarGroup extends LitElement {
  static styles = useStyles([styles]);

  static readonly metadata = {
    tag: 'nve-avatar-group',
    version: '0.0.0'
  };

  /** @private */
  declare _internals: ElementInternals;

  render() {
    return html`
    <div internal-host>
        <slot></slot>
    </div>
  `;
  }

  connectedCallback() {
    super.connectedCallback();
    attachInternals(this);
    this._internals.role = 'group';
  }
}
